import { fetchUserPermissions } from '../api/userApi';
import { Permission } from '../interfaces/Permissions';
import { OrganizationContext } from './OrganizationContext';
import React, { createContext, useContext, useEffect, useState } from 'react';

interface PermissionsContextProps {
	isUserPermissionAllowed: (requiredPermissions: string | undefined) => boolean;
	areAllPermissionsFetched: boolean;
}

export const PermissionsContext = createContext<PermissionsContextProps>({
	isUserPermissionAllowed: () => false,
	areAllPermissionsFetched: false,
});

export const PermissionsContextProvider = ({ children }: { children: React.ReactNode }) => {
	const [permissions, setPermissions] = useState<Permission[]>([]);
	const [areAllPermissionsFetched, setAreAllPermissionsFetched] = useState<boolean>(false);
	const { selectedOrg } = useContext(OrganizationContext);

	useEffect(() => {
		setAreAllPermissionsFetched(false);
		if (selectedOrg) {
			fetchUserPermissions()
				.then((permissions: Permission[]) => {
					setPermissions(permissions);
				})
				.finally(() => setAreAllPermissionsFetched(true));
		}
	}, [selectedOrg]);

	const isUserPermissionAllowed = (requiredPermission: string | undefined): boolean => {
		return requiredPermission ? permissions.some(permission => permission.name === requiredPermission) : true;
	};

	return (
		<PermissionsContext.Provider value={{ areAllPermissionsFetched, isUserPermissionAllowed }}>
			{children}
		</PermissionsContext.Provider>
	);
};
